import { useContext } from "react";

import ScrollContext from "../contexts/ScrollContext";

const useScroll = () => useContext(ScrollContext);

export default useScroll;
